const SUCCESS_APPLICATION = 'Application Submitted Successfully'
const BACK_TO_DASHBOARD = 'Back to Dashboard'

export { BACK_TO_DASHBOARD, SUCCESS_APPLICATION }
